import * as React from 'react';
import { root as rootCls } from './StatusTag.css';

export type StatusTagTone = 'neutral' | 'info' | 'success' | 'warn' | 'danger';

export interface StatusTagProps extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * Tone — selects the bg / text / border palette from the prototype's
   * `STAT_META` map. Defaults to `neutral` (= "Draft").
   */
  tone?: StatusTagTone;
  ref?: React.Ref<HTMLSpanElement>;
}

/**
 * StatusTag — small status pill ("Draft" / "✓ Synced" / "⚠ Needs Update"
 * / "In Review" / "Rejected") shown in the artifact metadata strip.
 *
 * Pulled out as a primitive because the prototype's `.work-state-badge`
 * has a distinct shape from the soft-fill `<Badge>` family — sharper
 * 4px corners, 1px border, 10/700 type, content rendered verbatim
 * (NOT uppercased; "Draft" stays "Draft" — the prototype does not
 * uppercase these labels).
 *
 * The `tone` prop selects bg / text / border from the prototype's
 * `STAT_META` map. Validated 2026-05-03.
 */
export function StatusTag({ tone = 'neutral', children, ref, className, ...rest }: StatusTagProps) {
  const cls = [rootCls({ tone }), className].filter(Boolean).join(' ');
  return (
    <span ref={ref} className={cls} {...rest}>
      {children}
    </span>
  );
}
StatusTag.displayName = 'StatusTag';
